module.exports = __webpack_public_path__ + "static/media/paw-hash.fdb75ee9.svg";